// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/edges/ButtonEdge.js (104 lines).
 * BYTE-IDENTICAL.
 *
 * v1 uses `reactflow` v11: `import { getSmoothStepPath, useReactFlow } from 'reactflow'`
 * v2 uses `@xyflow/react` v12: `import { getSmoothStepPath, useReactFlow } from '@xyflow/react'`
 * The two APIs are identical for getSmoothStepPath return shape [path, labelX, labelY]
 * and for useReactFlow().setEdges. Edge JSON shape is unchanged.
 */
import React from 'react';
import { getSmoothStepPath, useReactFlow } from '@xyflow/react';

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  markerEnd,
  ...props
}: any) {
  const isSelfConnect = props.source === props.target;

  // Self-connect arc path
  const radiusX = (sourceX - targetX) * 0.6;
  const radiusY = 50;
  const edgePathCenter = `M ${sourceX} ${sourceY} A ${radiusX} ${radiusY} 0 1 0 ${
    targetX + 2
  } ${targetY}`;

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 10,
  });

  // For self-loops use a fixed offset above the node
  const centerX = isSelfConnect ? sourceX : labelX;
  const centerY = isSelfConnect ? sourceY - 60 : labelY;

  const { setEdges } = useReactFlow();
  const onEdgeClick = () => {
    setEdges((edges: any[]) => edges.filter((edge: any) => edge.id !== id));
  };

  return (
    <>
      <path
        id={id}
        style={{ ...style, stroke: '#b0b7c3', strokeWidth: 1.5 }}
        className="react-flow__edge-path"
        d={isSelfConnect ? edgePathCenter : edgePath}
        markerEnd={markerEnd}
      />
      <foreignObject
        width={data?.label ? 60 : 24}
        height={22}
        x={centerX - (data?.label ? 30 : 12)}
        y={centerY - 11}
        style={{ overflow: 'visible' }}
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '3px',
            background: data?.label ? 'rgba(255,255,255,0.92)' : 'transparent',
            borderRadius: 6,
            padding: data?.label ? '1px 5px' : '0',
            boxShadow: data?.label ? '0 1px 4px rgba(0,0,0,0.12)' : 'none',
            border: data?.label ? '1px solid #e2e8f0' : 'none',
          }}
        >
          {data?.label && (
            <span
              style={{
                fontSize: 9,
                fontWeight: 700,
                color: '#475569',
                whiteSpace: 'nowrap',
              }}
            >
              {data.label}
            </span>
          )}
          {!data?.locked && (
            <button
              onClick={onEdgeClick}
              title="Remove connection"
              style={{
                width: 16,
                height: 16,
                border: 'none',
                borderRadius: '50%',
                background: '#fee2e2',
                color: '#ef4444',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 9,
                fontWeight: 700,
                flexShrink: 0,
                padding: 0,
              }}
            >
              ×
            </button>
          )}
        </div>
      </foreignObject>
    </>
  );
}
